import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-47bc458a"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "snore-video"
};
var _hoisted_2 = {
  class: "video-list"
};
var _hoisted_3 = {
  class: "video-item"
};
var _hoisted_4 = {
  class: "title"
};

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "dot"
  }, null, -1);
});

var _hoisted_6 = ["src", "name", "onPlay"];
var _hoisted_7 = ["onClick"];
var _hoisted_8 = ["src"];
var _hoisted_9 = ["src"];
var _hoisted_10 = ["src"];
var _hoisted_11 = {
  key: 0,
  class: "line"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.finalSnoreList, function (item, index) {
    return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", null, _toDisplayString($options.timeFormat(item.startSnore, 'HH:mm:ss')), 1)]), _createElementVNode("audio", {
      ref_for: true,
      ref: "audios",
      class: "audio",
      controls: "",
      src: item.url,
      controlslist: "nodownload",
      name: 'audio' + index,
      onEnded: _cache[0] || (_cache[0] = function () {
        return $options.onH5AudioEnd && $options.onH5AudioEnd.apply($options, arguments);
      }),
      onPlay: function onPlay($event) {
        return $options.onH5AudioPlay(item);
      },
      onPause: _cache[1] || (_cache[1] = function () {
        return $options.onH5AudioPause && $options.onH5AudioPause.apply($options, arguments);
      })
    }, null, 40, _hoisted_6), _createElementVNode("div", {
      class: "content",
      onClick: function onClick($event) {
        return $options.play(item, index);
      }
    }, [_withDirectives(_createElementVNode("img", {
      class: "icon icon1",
      src: $data.imgVolumeMute
    }, null, 8, _hoisted_8), [[_vShow, $data.isPlayType === 1 && $data.isPlayId == item.localPathId]]), _withDirectives(_createElementVNode("img", {
      class: "icon icon2",
      src: $data.imgVolumeDown
    }, null, 8, _hoisted_9), [[_vShow, $data.isPlayType === 2 && $data.isPlayId == item.localPathId]]), _withDirectives(_createElementVNode("img", {
      class: "icon",
      src: $data.imgVolumeUp
    }, null, 8, _hoisted_10), [[_vShow, $data.isPlayId != item.localPathId || !$data.isPlayType]]), _createElementVNode("div", null, _toDisplayString($options.getTimeRangeSeconds(item)), 1)], 8, _hoisted_7), index < $data.showLength - 1 && index < $options.finalSnoreList.length - 1 ? (_openBlock(), _createElementBlock("div", _hoisted_11)) : _createCommentVNode("", true)], 512)), [[_vShow, index < $data.showLength]]);
  }), 256))]), $props.more && $options.finalSnoreList.length > $data.showLength && $data.showLength !== $data.maxShowLength ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "more",
    onClick: _cache[2] || (_cache[2] = function () {
      return $options.showMore && $options.showMore.apply($options, arguments);
    })
  }, _toDisplayString(_ctx.$t("message.snore.more")), 1)) : _createCommentVNode("", true)]);
}